import React from "react";
import CustomerCheckout from "../../components/user/Checkout";
import Layout from "../../components/user/Layout";

function CheckoutPage() {
  return (
     <Layout>

      <CustomerCheckout />

    </Layout>
  );
}

export default CheckoutPage;
